module.exports = {
          srcSet: __webpack_public_path__ + "images/2018-f95a841a1a8c0f7853ea0a490f88cc9e-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/2018-6550c3854ce49aab8beaf1dccebc5f26-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/2018-f95a841a1a8c0f7853ea0a490f88cc9e-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/2018-6550c3854ce49aab8beaf1dccebc5f26-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/2018-f95a841a1a8c0f7853ea0a490f88cc9e-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/2018-f95a841a1a8c0f7853ea0a490f88cc9e-320.jpg"},
          
          width: 320,
          height: 251
        }